import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './app-home.component.html',
  styleUrl: './app-home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppHomeComponent {}
